// Module
var code = "<!DOCTYPE html> <select class=\"iw-time-selector__value form-control\"></select>";
// Exports
export default code;